import { GameManager } from "../GameManager";
import { AudioManager } from "../AudioManager";
import { GameConstants } from "../GameConstants";
import { GameVars } from "../GameVars";
import { Game } from "../Game";

export class PreloadScene extends Phaser.Scene {

    public static currentInstance: PreloadScene;

    private static readonly PRELOAD_BAR_WIDTH = 600;

    public loadingLabel: Phaser.GameObjects.Text;

    private progressBar: Phaser.GameObjects.Graphics;
    private kingSurfer: Phaser.GameObjects.Image;
    private scaledItemsContainer: Phaser.GameObjects.Container;

    private static onAudioLoaded(): void {

        const w = window.innerWidth;
        const h = window.innerHeight;

        if (Game.currentInstance.device.os.desktop || h <  w) {

            if (PreloadScene.currentInstance.sys.game.device.os.desktop) {
            
                GameManager.onGameAssetsLoaded();

            } else {

                PreloadScene.currentInstance.loadingLabel.destroy();

                const tapLabel = PreloadScene.currentInstance.add.text(GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2, "TAP ANYWHERE TO START", {fontFamily: "Rubik-Regular", fontSize: "50px", color: "#FFFFFF"});
                tapLabel.scaleX = GameVars.scaleX;
                tapLabel.setOrigin(.5);

                PreloadScene.currentInstance.tweens.add({
                    targets: tapLabel,
                    alpha: .35,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    duration: 500,
                    repeat: -1,
                    yoyo: true
                });
                
                PreloadScene.currentInstance.input.on("pointerup", () => {
    
                    PreloadScene.currentInstance.game.scale.startFullscreen();

                    // calcular los factores de escala
                       
                    PreloadScene.currentInstance.time.addEvent({ delay: 100, callback: () => { 

                        GameVars.currentScene.game.scale.displaySize = GameVars.currentScene.game.scale.parentSize;
                        Game.currentInstance.scale.refresh();
            
                        GameVars.aspectRatio = window.innerWidth / window.innerHeight;
                        GameVars.contrascaleX = (GameVars.aspectRatio - (4 / 3)) * .2;
            
                        if (window.innerHeight > window.innerWidth) {
                            GameVars.scaleX = (GameConstants.GAME_WIDTH / GameConstants.GAME_HEIGHT) / (window.innerWidth / window.innerHeight);
                            GameVars.scaleY = (GameConstants.GAME_HEIGHT / GameConstants.GAME_WIDTH) / (window.innerHeight / window.innerWidth);
            
                        } else {
                            GameVars.scaleX = (GameConstants.GAME_WIDTH / GameConstants.GAME_HEIGHT) / (window.innerWidth / window.innerHeight);
                            GameVars.scaleY = (GameConstants.GAME_HEIGHT / GameConstants.GAME_WIDTH) / (window.innerHeight / window.innerWidth);
                        }

                        GameManager.onGameAssetsLoaded();
            
                    }, callbackScope: PreloadScene.currentInstance});
                    
                }, this);
            }

        } else {

            document.getElementById("orientation").style.display = "block";
            document.getElementById("content").style.display = "none"; 
        }
    }
    
    constructor() {

        super("PreloadScene");

        PreloadScene.currentInstance = this;
    }

    public preload(): void {

        GameManager.setCurrentScene(this);

        this.composeScene();

        this.loadAssets();
    }

    public create(): void {

        this.loadAudio();
    }
    
    private composeScene(): void {

        const background = this.add.graphics();
        background.fillStyle(0x22344D);
        background.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);

        this.scaledItemsContainer = this.add.container(GameConstants.GAME_WIDTH / 2, 460);
        this.scaledItemsContainer.scaleX = GameVars.scaleX;

        const barWidth = PreloadScene.PRELOAD_BAR_WIDTH;
        const barWHeight = 48;
        const borderWidth = 5;

        const preloadBarCapsuleBorder = new Phaser.GameObjects.Graphics(this);
        preloadBarCapsuleBorder.fillStyle(0xFFFFFF);
        preloadBarCapsuleBorder.fillRect(0, 0, barWidth + borderWidth * 2, barWHeight + borderWidth * 2);
        preloadBarCapsuleBorder.x = - barWidth / 2 - borderWidth;
        preloadBarCapsuleBorder.y = -borderWidth;
        this.scaledItemsContainer.add(preloadBarCapsuleBorder); 

        const preloadBarCapsule = new Phaser.GameObjects.Graphics(this);
        preloadBarCapsule.fillStyle(0x6D9E48);
        preloadBarCapsule.fillRect(0, 0, barWidth, barWHeight );
        preloadBarCapsule.x = - barWidth / 2;
        this.scaledItemsContainer.add(preloadBarCapsule); 

        this.progressBar = new Phaser.GameObjects.Graphics(this);
        this.progressBar.fillStyle(0x22344D);
        this.progressBar.fillRect(0, 0, barWidth, barWHeight );
        this.progressBar.x = - barWidth / 2;
        this.progressBar.scaleX = 0;
        this.scaledItemsContainer.add(this.progressBar); 

        this.kingSurfer = new Phaser.GameObjects.Image(this, this.progressBar.x + this.progressBar.scaleX * barWidth, -10, "preload_surfer");
        this.kingSurfer.originX = 1;
        this.scaledItemsContainer.add(this.kingSurfer); 

        this.loadingLabel = new Phaser.GameObjects.Text(this, 0, 75, " LOADING...", {fontFamily: "Arial", fontSize: "32px", color: "#FFFFFF"});
        this.loadingLabel.setOrigin(.5);
        this.scaledItemsContainer.add(this.loadingLabel); 
    }

    private loadAssets(): void {

        if (GameConstants.DEVELOPMENT) {
            this.load.atlas("texture_atlas_0", "assets/texture_atlas_0.png", "assets/texture_atlas_0.json");
        }
        
        this.load.atlas("texture_atlas_1", "assets/texture_atlas_1.png", "assets/texture_atlas_1.json");
        this.load.atlas("texture_atlas_2", "assets/texture_atlas_2.png", "assets/texture_atlas_2.json");
        this.load.atlas("texture_atlas_3", "assets/texture_atlas_3.png", "assets/texture_atlas_3.json");
        this.load.atlas("texture_atlas_4", "assets/texture_atlas_4.png", "assets/texture_atlas_4.json");
        this.load.atlas("texture_atlas_5", "assets/texture_atlas_5.png", "assets/texture_atlas_5.json");
        this.load.image("background", "assets/background_menu.jpg");
        this.load.json("sound", "assets/audio/sound.json");
        this.load.json("music", "assets/audio/music.json");
        this.load.json("enemies", "assets/config/enemies.json");
        this.load.json("turrets", "assets/config/turrets.json");
        this.load.json("waves_1", "assets/config/waves_1.json");
        this.load.json("waves_2", "assets/config/waves_2.json");
        this.load.json("waves_3", "assets/config/waves_3.json");
        this.load.json("waves_4", "assets/config/waves_4.json");
        this.load.json("waves_5", "assets/config/waves_5.json");
        this.load.html("input-text", "assets/dom/inputText.html");
        this.load.html("initial-coins", "assets/dom/initialCoins.html");

        this.load.image("tileset1", "assets/tilemaps/tileset1.png");
        this.load.image("tileset2", "assets/tilemaps/tileset2.png");
        this.load.image("tileset3", "assets/tilemaps/tileset3.png");
        this.load.image("tileset4", "assets/tilemaps/tileset4.png");
        this.load.image("tileset5", "assets/tilemaps/tileset5.png");
        
        for (let i = 0; i <= GameConstants.TOTAL_MAPS; i++) {
            this.load.tilemapTiledJSON("map_" + i, "assets/tilemaps/map" + i + ".json");
        }

        this.load.on("progress", this.updateLoadedPercentage, this);
    }

    private updateLoadedPercentage(percentageLoaded: number): void {

        if (this.progressBar.scaleX < percentageLoaded) {

            this.progressBar.scaleX = percentageLoaded;
            this.kingSurfer.x = this.progressBar.x + this.progressBar.scaleX * PreloadScene.PRELOAD_BAR_WIDTH;

            this.tweens.add({
                targets: this.kingSurfer,
                x: this.progressBar.x + this.progressBar.scaleX * PreloadScene.PRELOAD_BAR_WIDTH,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 300
            });
        }
    }

    private loadAudio(): void {

        let soundtrackJSON = this.cache.json.get("music");
        soundtrackJSON = JSON.parse(JSON.stringify(soundtrackJSON).replace("urls", "src"));

        AudioManager.soundtrack = new Howl(soundtrackJSON);
    
        AudioManager.soundtrack.on("load", function(): void {

            let effectsJSON = PreloadScene.currentInstance.cache.json.get("sound");
            effectsJSON = JSON.parse(JSON.stringify(effectsJSON).replace("urls", "src"));

            AudioManager.effects = new Howl(effectsJSON);

            AudioManager.effects.on("load", PreloadScene.onAudioLoaded);
        });
    }   
}
